import { Card, CardContent, Typography, Button, DialogContent, Dialog, DialogActions, List, ListItem, Grid, Chip, LinearProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { HoverModal } from '../hoverModal';
import { MPubCardSimple } from '../mPubCard';
import socketIOClient from "socket.io-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Countdown from 'react-countdown';
import EvidenceCreationPage from '../evidenceCreation.jsx';
import {ManiaRound} from './maniaRound';
import IncubatorAddCardTab from '../incubatorAddCardTab';
import Toastr from 'toastr';
import ManiaAddExistingCard from './maniaAddExistingCard.jsx';
import ConjectureCreation from '../conjectureCreation.jsx';
import ManiaListView from './maniaListView.jsx';
const AjaxFunctions = require('../../ajaxFunctions');
const SharedModels = require('../../../../../shared/sharedModels');
const moment = require('moment');
require('moment-timezone');
const SharedConstants = require('../../../../../shared/sharedConstants');
const ToastAlert = require('../../../client/components/toastAlert');

export function Mania(props) {
    let [maniaData, setManiaData] = useState();
    let [maniaMatchData, setManiaMatchData] = useState([]);
    let [userVotes, setUserVotes] = useState([])
    let { portfolio, editMode, forceShowScore } = props;
    let idPortfolio = portfolio.id;
    let { idMania, suggestionEndTime, items, idOwner, owners } = portfolio;
    let isSponsor = (idOwner == window.globals.idUser || owners.find(owner => owner.idUser == window.globals.idUser))

    useEffect(() => {
        const socket = socketIOClient(window.globals.socketConnection, { transports: ["websocket"] });
        socket.on(`UpdateManiaMatches${idMania}`, async data => {
            setManiaMatchData(data)
        });
        socket.on(`UpdateMania${idMania}`, async data => {
            setManiaData(data)
        });
        return () => socket.disconnect();
    }, []);

    useEffect(() => {
        const getManiaData = async () => {
            let maniaData = await AjaxFunctions.getManiaByID(idPortfolio, idMania);
            let maniaMatchData = await AjaxFunctions.getManiaMatchesByID(idPortfolio, idMania);
            let userVotes = await AjaxFunctions.getManiaVotesForUser(idMania, idPortfolio);
            setManiaData(maniaData);
            setManiaMatchData(maniaMatchData);
            setUserVotes(userVotes);
        }
        getManiaData();

    }, [idMania]);

    let addManiaVote = async (idManiaMatch) => {
        try {
            await AjaxFunctions.addVoteToMania(idManiaMatch, idPortfolio, idMania);
            let userVotes = await AjaxFunctions.getManiaVotesForUser(idMania, idPortfolio);
            setUserVotes(userVotes);
        }
        catch(e){
            Toastr.error(e);
        }
    }
    let deleteManiaVote = async (idManiaMatch) => {
        try {
            await AjaxFunctions.deleteVoteFromMania(idManiaMatch, idPortfolio, idMania);
            let userVotes = await AjaxFunctions.getManiaVotesForUser(idMania, idPortfolio);
            setUserVotes(userVotes);
        }
        catch(e) {
            Toastr.error(e);
        }
    }

    if (!maniaData) {
        return (
            <Card>
                <CardContent>
                    <LinearProgress />
                </CardContent>
            </Card>
        )
    }

    let contributedUserItems = items.filter(item => ((item.idSubmitter == window.globals.idUser) && (maniaMatchData.find(maniaItem => maniaItem.idCard == item.id))));
    let maniaStarted = suggestionEndTime ? moment(suggestionEndTime.toString().slice(0,10)).utcOffset("-05:00", true).endOf('day').isBefore(new Date()) : false;
    let currentRoundDate = maniaData[`round${maniaData.currentRound}EndTime`];
    let addCardComponent =
        <ManiaAddExistingCard
            cardTypes={[{value: SharedConstants.CardType.Reasoning, label: 'Conjecture'}]}
            cardFilter={cards => cards.filter(c => c.cardType === SharedConstants.CardType.Reasoning)}
            addCardFunction={props.addCardFunction}
            tab={props.tab}
            getUpdatedPortfolioData={props.getUpdatedPortfolioData}
        />
    return (
        <Card>
            <CardContent>
                <div>
                    <Typography variant="h5" component="h2" color='primary' className='incubator-card-name'>
                        {`POLYPLEXUS MANIA ${editMode ? `EDITOR` : ''} ${maniaData.title ? `: ${maniaData.title}` : ''}`}
                    </Typography>
                    <Typography className='incubator-card-name' gutterBottom>
                        {`${maniaData.subTitle ? maniaData.subTitle : ''}`}
                    </Typography>
                    <hr />
                    {((!maniaStarted && !editMode)) && <CountdownContainer time={suggestionEndTime} isSubmissionPeriod/>}
                    {(!maniaStarted && !editMode && (isSponsor || contributedUserItems.length < 4)) &&
                        <AddCardsContainer
                           createCardFunction={props.createCardFunction}
                           addCardComponent={addCardComponent}
                           maniaData={maniaData}
                           lastFilterFunction={props.lastFilterFunction}
                           incubatorEvidenceCards={items.filter(x => x.cardType === 1 && x.voteType === 2)}
                        />}
                    {(maniaData.currentRound <= 6 && (maniaStarted) && !editMode) && <VotingContainer maniaData={maniaData} idPortfolio={idPortfolio} />}
                    {!editMode && <DeleteVotesContainer maniaData={maniaData} idPortfolio={idPortfolio} />}
                    {/* maniaStarted && <TotalVotesContainer maniaData={maniaData} maniaMatchData={maniaMatchData} /> */}
                    {(maniaStarted) && <CountdownContainer time={currentRoundDate} currentRound={maniaData.currentRound} />}
                    <ManiaContainer
                       maniaStarted={maniaStarted}
                       maniaMatchData={maniaMatchData}
                       maniaData={maniaData}
                       contributedUserItems={contributedUserItems}
                       idPortfolio={idPortfolio}
                       editMode={editMode}
                       forceShowScore={forceShowScore}
                       userVotes={userVotes}
                       addManiaVote={(idManiaMatch) => addManiaVote(idManiaMatch)}
                       deleteManiaVote={(idManiaMatch) => deleteManiaVote(idManiaMatch)}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

function TotalVotesContainer(props) {
    let { maniaData, maniaMatchData, } = props;
    let voteCount = maniaMatchData.filter(b => b.idRound == maniaData.currentRound).reduce((a, b) => a + b.score, 0);
    let totalVotes = parseInt(voteCount) + parseInt(maniaData.voteFudgeFactor);
    return (<div>
        <Chip style={{ width: '200px', marginBottom: '1em' }} label={`Total Votes: ${totalVotes ? totalVotes : '0'}`} variant="outlined"></Chip>
    </div>)
}
function CountdownContainer(props) {
    let { time, isSubmissionPeriod, currentRound } = props;
    if (currentRound == 5) currentRound = "Semifinals"
    else if (currentRound == 6) currentRound = "Finals"
    else currentRound = currentRound ? `Round ${currentRound}` : 'Round'

    let title = isSubmissionPeriod ? "Submission Period" : currentRound;
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        return completed ? <span>{`${title} Has Ended.`}</span> :
            <span>{title} Ends In: {days} {`day${days == 1 ? '' : 's'}`}, {hours} hours, {minutes} minutes, and {seconds} seconds.</span>
    };
    let formattedTime = time ? moment(time.toString().slice(0, 10)).utcOffset("-05:00", true).endOf('day') : null;
    return (time ? <Typography style={{ textAlign: 'center' }}>
        <Countdown date={formattedTime.toDate()} renderer={renderer} />
    </Typography> : <Typography style={{ textAlign: 'center' }}>{currentRound > 6?`${title} Has Not Been Provided.`:'Mania Tournament Has Ended.'}</Typography>)
}

function DeleteVotesContainer(props) {
    let { maniaData } = props;
    let [userVotes, setUserVotes] = useState([]);
    let [open, setOpen] = useState(false);
    const getManiaVotesForUser = async () => {
        let userVotes = await AjaxFunctions.getManiaVotesForUser(maniaData.idMania, props.idPortfolio);
        if (!userVotes.length == 0) {
            setOpen(false)
        }
        setUserVotes(userVotes);
    }
    useEffect(() => {
        getManiaVotesForUser();
    }, [props.maniaData, props.maniaMatchData]);

    let deleteUserVote = async (idManiaMatch) => {
        try {
            await AjaxFunctions.deleteVoteFromMania(idManiaMatch, props.idPortfolio, maniaData.idMania);
            ToastAlert.success("Vote Deleted!");
            getManiaVotesForUser();
        } catch (err) {
            console.log(err)
            ToastAlert.error("Error Deleting Vote.")
        }
    }
    return (
        <div>
            {userVotes.length > 0 &&
                <div>
                    <Button className="material-button" style={{ textTransform: 'none', width: '200px', marginBottom: '10px' }}
                        variant='outlined' color="primary" onClick={() => setOpen(true)}>Edit Votes</Button>
                    <Dialog open={open} maxWidth="md">
                        <DialogContent>
                            <Typography variant="h5" component="h2" color='primary'>
                                Your Votes: Round {maniaData.currentRound}
                            </Typography>
                            <Typography className='incubator-card-name' gutterBottom>
                                Click the change button to remove your vote.
                    </Typography>
                            <List>
                                {userVotes.map(userVote => {
                                    let formattedCard = SharedModels.formatGenericCard(userVote);
                                    return (<ListItem key={`editVote_${userVote.id}`}>
                                        <Grid item xs={3}>
                                            <Button className="material-button" fullWidth onClick={() => deleteUserVote(userVote.idManiaMatch)}
                                                variant="outlined">Change</Button>
                                        </Grid>
                                        <Grid item xs={9} style={{ marginLeft: '1em' }}>
                                            <MPubCardSimple initialTab="mania" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                                        </Grid>
                                    </ListItem>)
                                })}
                            </List>
                        </DialogContent>
                        <DialogActions>
                            <Button className="material-button" onClick={() => setOpen(false)}>Close</Button>
                        </DialogActions>
                    </Dialog></div>}
        </div>
    )
}
function VotingContainer(props) {
    let { maniaData } = props;
    let [open, setOpen] = useState(false);
    let [voteData, setVoteData] = useState([])
    let [currentItem, setCurrentItem] = useState(null)
    let [currentItemIndex, setCurrentItemIndex] = useState(0)
    let [idManiaMatch, setIDManiaMatch] = useState(null);

    const getManiaVotesForUser = async () => {
        let voteData = await AjaxFunctions.getManiaVotesForUser(maniaData.idMania, props.idPortfolio);
        if (Object.keys(voteData).length > 0) {
            setCurrentItem(Object.keys(voteData)[currentItemIndex])
        }
        setVoteData(voteData);
    }

    useEffect(() => {
        getManiaVotesForUser();
    }, [props.maniaData, props.maniaMatchData]);

    let addVoteToMania = async () => {
        try {
            await AjaxFunctions.addVoteToMania(idManiaMatch, props.idPortfolio, maniaData.idMania);
            setIDManiaMatch(null);
            await getMissingManiaVotesForUser();
            ToastAlert.success("Vote Submitted!")
        } catch (err) {
            console.log(err)
            ToastAlert.error("Error Submitting Vote.")
        }
    }
    let VotingComponent = (votingProps) => {
        let { currentMatch } = votingProps;
        if (!currentMatch) {
            setOpen(false)
            return (<div />)
        }
        return (
            <div>
                <List>
                    {currentMatch.map(c => {
                        let formattedCard = SharedModels.formatGenericCard(c);
                        return (<ListItem key={`editVote_${c.id}`}>
                            <Grid item xs={2}>
                                <Button color="primary" style={{ textTransform: 'none' }} onClick={() => setIDManiaMatch(c.idManiaMatch)} fullWidth variant={idManiaMatch == c.idManiaMatch ? 'contained' : 'outlined'}>Select</Button>
                            </Grid>
                            <Grid item xs={10} style={{ marginLeft: '1em' }}>
                                <MPubCardSimple initialTab="madness" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                            </Grid>
                        </ListItem>)
                    })}
                </List>
            </div>
        );
    }
    return (<div>
        {(Object.keys(voteData).length > 0 && Object.keys(voteData)[currentItemIndex]) && <Button className="material-button" variant='outlined' color="primary"
            style={{ textTransform: 'none', width: '200px', marginBottom: '10px'}} color="secondary" onClick={() => setOpen(true)}>VOTE</Button>}
        <Dialog open={open} maxWidth="md" fullWidth>
            <DialogContent>
                <VotingComponent currentMatch={voteData[currentItem]} />
            </DialogContent>
            <DialogActions>
                <Button disabled={idManiaMatch == null} className="material-button" onClick={() => addVoteToMania()}>Vote</Button>
                <Button className="material-button" onClick={() => {
                    let nextItem = Object.keys(voteData)[currentItemIndex + 1];
                    if (!nextItem) {
                        setOpen(false);
                    }
                    setCurrentItem(nextItem ? nextItem : Object.keys(voteData)[0]);
                    setCurrentItemIndex(nextItem ? currentItemIndex + 1 : 0);
                }}>Skip</Button>
                <Button className="material-button" onClick={() => setOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </div>)
}

function ManiaContainer(props) {
    let { maniaData, maniaMatchData, contributedUserItems, maniaStarted, editMode, forceShowScore, userVotes } = props;
    let visibleManiaMatchData = (!maniaStarted && !editMode) ? [] : maniaMatchData;
    let isCurrentRound = (round) => {
        return maniaData.currentRound >= 7 ? "current" : (round == maniaData.currentRound || !maniaStarted) ? "current" : ""
    }

    return (
        <div>
        {(!maniaStarted && !editMode) &&
            <div>
                {contributedUserItems.length == 0 && <Typography color="primary" variant="h6" style={{ textAlign: 'center' }}>{`You Haven’t Submitted a µPub. Time is running out!`}</Typography>}
                {contributedUserItems.length > 0 && <Typography color="primary" variant="h6" style={{ textAlign: 'center' }}>{`Your Submitted Conjecture`}</Typography>}
                <List>
                    {contributedUserItems.map(item => {
                        let maniaItem = maniaMatchData.find(maniaItem => (maniaItem.idCard == item.id && maniaItem.cardType == item.cardType))
                        let formattedCard = SharedModels.formatGenericCard(maniaItem);
                        return (<ListItem key={`displayCard_${maniaItem.id}`}>
                            <MPubCardSimple initialTab="madness" idIncubator={props.idPortfolio} card={formattedCard}></MPubCardSimple>
                        </ListItem>)
                    })}
                </List>
                <hr/>
            </div> }
            <section className="mania">
                <div id="mania-container">
                    <div className="split split-one">
                        <ManiaRound
                           className={`round round-one ${isCurrentRound(1)}`}
                           matchData={visibleManiaMatchData}
                           maniaData={maniaData}
                           title="Round 1"
                           idRound="1"
                           side="left"
                           numMatches="32"
                           topClass="topLeftMania"
                           bottomClass="bottomLeftMania"
                           editMode={(editMode && maniaData.currentRound === 1)}
                           disableLink={editMode}
                           forceShowScore={forceShowScore}
                           userVotes={userVotes}
                           addManiaVote={(idManiaMatch) => props.addManiaVote(idManiaMatch)}
                           deleteManiaVote={(idManiaMatch) => props.deleteManiaVote(idManiaMatch)}
                           maxVotes={10}
                        />
                        <ManiaRound
                           className={`round ${isCurrentRound(2)}`}
                           matchData={visibleManiaMatchData}
                           maniaData={maniaData}
                           title="Round 2"
                           idRound="2"
                           side="left"
                           numMatches="10"
                           topClass="topLeftMania"
                           bottomClass="bottomLeftMania"
                           disableLink={editMode}
                           forceShowScore={forceShowScore}
                           userVotes={userVotes}
                           addManiaVote={(idManiaMatch) => props.addManiaVote(idManiaMatch)}
                           deleteManiaVote={(idManiaMatch) => props.deleteManiaVote(idManiaMatch)}
                           maxVotes={3}
                        />
                        <ManiaRound
                           className={`round ${isCurrentRound(3)}`}
                           matchData={visibleManiaMatchData}
                           maniaData={maniaData}
                           title="Round 3"
                           idRound="3"
                           side="left"
                           numMatches="3"
                           topClass="topLeftMania"
                           bottomClass="bottomLeftMania"
                           disableLink={editMode}
                           forceShowScore={forceShowScore}
                           userVotes={userVotes}
                           addManiaVote={(idManiaMatch) => props.addManiaVote(idManiaMatch)}
                           deleteManiaVote={(idManiaMatch) => props.deleteManiaVote(idManiaMatch)}
                           maxVotes={1}
                        />
                    </div>
                    <div className="champion"><div className={`final ${isCurrentRound(6)}`}>
                            <FontAwesomeIcon icon={[`fa`, 'trophy']} size="4x" color="lightgrey" />
                            <ManiaRound
                               isChampionship
                               isFinal
                               matchData={visibleManiaMatchData}
                               maniaData={maniaData}
                               title="Winner"
                               numMatches="1"
                               idRound="4"
                               userVotes={userVotes}
                               disableLink={editMode}
                               forceShowScore={forceShowScore}
                               maxVotes={0}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

function AddCardsContainer(props) {
    let [addCardOpen, setAddCardOpen] = useState(false);
    let [createCardOpen, setCreateCardOpen] = useState(false);
    return (<div>
        <div style={{ textAlign: 'center' }}>
            {
                props.addCardComponent &&
                <Button
                   className="material-button"
                   variant='outlined'
                   style={{ textTransform: 'none' }}
                   onClick={() => setAddCardOpen(true)}
                >
                    ADD EXISTING CONJECTURE
                </Button>
            }
            {
                (props.createCardFunction) &&
                <Button
                   className="material-button"
                   variant='outlined'
                   style={{ textTransform: 'none', marginLeft: '1em' }}
                   onClick={() => setCreateCardOpen(true)}
                >
                    ADD NEW CONJECTURE
                </Button>
            }
        </div>
        <hr />
        <Dialog open={addCardOpen} maxWidth="lg" fullWidth>
            <DialogContent id={'maniaAddExistingDialogContent'}>
                {props.addCardComponent}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setAddCardOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={createCardOpen} maxWidth="lg" fullWidth>
            <DialogContent id={'maniaCreateConjectureDialogContent'}>
                <Grid container spacing={2} >
                    <Grid item className='left-bar' sm={3}>
                        <ConjectureCreation
                           hideCancelButton={true}
                           onCreate={(idCard) => {
                               setCreateCardOpen(false);
                               props.createCardFunction(idCard);
                           }}
                        />
                    </Grid>
                    <Grid item sm={9}>
                        <ManiaListView
                           isCreatingConjecture={true}
                           lastFilterFunction={props.lastFilterFunction}
                           overrideFilteredCardList={props.incubatorEvidenceCards}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setCreateCardOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    </div>)
}

